import { defaultStore } from '@/library/firebase'

export const savePayment = (reservationId, paymentInfo) => {
  console.log({ reservationId, ...paymentInfo })
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('reservations_payment')
      .add({ reservationId, ...paymentInfo })
      .then(snap => {
        resolve(snap)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const requestReservation = reservationInfo => {
  console.log('request reservation ', reservationInfo)
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('reservations')
      .add(reservationInfo)
      .then(snap => {
        resolve(snap)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getRequestReservations = uid => {
  return new Promise((resolve, reject) => {
    const result = []
    defaultStore
      .collection('reservations')
      .where('uid', '==', uid)
      // .where('status', '==', 'request')
      .orderBy('createDate', 'desc')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          if (doc.exists) {
            const data = doc.data()
            // console.log('booking res:', data)
            // if (data.status === 'booking' || data.status === 'decline' || data.status === 'request') {
            if (data.status === 'booking' || data.status === 'request') {
              result.push(Object.assign(data, { id: doc.id }))
            }
          }
        })
        resolve(result)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getRequestReservationsPrevious = uid => {
  return new Promise((resolve, reject) => {
    const result = []
    defaultStore
      .collection('reservations')
      .where('uid', '==', uid)
      // .where('status', '==', 'request')
      .orderBy('createDate', 'desc')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          if (doc.exists) {
            const data = doc.data()
            console.log('reservation response:', data)
            if (data.status === 'uploaded' || data.status === 'decline') {
              result.push(Object.assign(data, { id: doc.id }))
            }
          }
        })
        resolve(result)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getRequestReservationsForPhotographer = uid => {
  console.log('uid:', uid)
  return new Promise((resolve, reject) => {
    const result = []
    defaultStore
      .collection('reservations')
      .where('photographerId', '==', uid)
      .where('status', '==', 'request')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          if (doc.exists) {
            result.push(Object.assign(doc.data(), { id: doc.id }))
          }
        })
        resolve(result)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getBookingReservationsForPhotographer = uid => {
  return new Promise((resolve, reject) => {
    const result = []
    defaultStore
      .collection('reservations')
      .where('photographerId', '==', uid)
      // .where('status', '==', 'booking')
      .orderBy('createDate', 'desc')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          if (doc.exists) {
            const data = doc.data()
            console.log('booking res:', data.status)
            if (data.status === 'booking' || data.status === 'decline') {
              result.push(Object.assign(data, { id: doc.id }))
            }
          }
        })
        resolve(result)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getNeedUploadReservationsForPhotographer = uid => {
  return new Promise((resolve, reject) => {
    const result = []
    defaultStore
      .collection('reservations')
      .where('photographerId', '==', uid)
      // .where('status', '==', 'booking')
      .orderBy('createDate', 'desc')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          if (doc.exists) {
            const data = doc.data()
            console.log('booking res:', data.status)
            if (data.status === 'done' || data.status === 'uploaded') {
              result.push(Object.assign(data, { id: doc.id }))
            }
          }
        })
        resolve(result)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const updateRequestReservation = (reservationId, updateInfo) => {
  console.log('update request reservation ', reservationId, updateInfo)
  delete updateInfo['id']
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('reservations')
      .doc(reservationId)
      .update(updateInfo)
      .then(res => {
        resolve(res)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const setRequestReservation = (reservationId, setInfo) => {
  console.log('set request reservation ', reservationId, setInfo)
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('reservations')
      .doc(reservationId)
      .get()
      .then(doc => {
        console.log('doc:', doc.data())
        if (doc.exists) {
          // 셋업은 존재하는 파일이 있어야지만 해야하고, 있다면 머지해서 같이
          // 셋업해야 한다.
          const data = Object.assign(doc.data(), setInfo)
          console.log('new set data:', data)
          defaultStore
            .collection('reservations')
            .doc(reservationId)
            .set(data)
            .then(res => {
              resolve(res)
            })
            .catch(error => {
              console.log('Error getting document:', error)
              reject(error)
            })
        } else {
          resolve(false)
        }
      })
  })
}
